const initialState = {
    isFaqDialogOpened: false,
    isDownloadDialogOpened: false,
    registeredCourses: [],
    timetable: {},
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_COURSE': {
            const { courseCode, sections } = action.payload;
            if (state.timetable[courseCode]) return state;

            const newRegisteredCourses = [
                ...state.registeredCourses,
                courseCode,
            ];

            return {
                ...state,
                registeredCourses: newRegisteredCourses,
                timetable: {
                    ...state.timetable,
                    [courseCode]: [...new Set(sections)],
                },
            };
        }

        case 'SET_COURSE_SECTIONS': {
            const { courseCode, sections } = action.payload;
            if (!state.timetable[courseCode]) return state;

            return {
                ...state,
                timetable: {
                    ...state.timetable,
                    [courseCode]: [...new Set(sections)],
                },
            };
        }

        case 'REMOVE_COURSE': {
            const { courseCode } = action.payload;
            const newRegisteredCourses = state.registeredCourses
                .filter(registeredCourseCode => registeredCourseCode !== courseCode);

            const newTimetable = {
                ...state.timetable,
            };
            delete newTimetable[courseCode];

            return {
                ...state,
                registeredCourses: newRegisteredCourses,
                timetable: newTimetable,
            };
        }

        case 'HYDRATE_TIMETABLE': {
            const timetable = action.payload.timetable || {};
            return {
                ...state,
                registeredCourses: Object.keys(timetable),
                timetable,
            };
        }

        case 'OPEN_FAQ_DIALOG': {
            return {
                ...state,
                isFaqDialogOpened: true,
            };
        }

        case 'CLOSE_FAQ_DIALOG': {
            return {
                ...state,
                isFaqDialogOpened: false,
            }
        }

        case 'OPEN_DOWNLOAD_DIALOG': {
            return {
                ...state,
                isDownloadDialogOpened: true,
            };
        }

        case 'CLOSE_DOWNLOAD_DIALOG': {
            return {
                ...state,
                isDownloadDialogOpened: false,
            };
        }

        default: {
            return state;
        }
    }
};

export default appReducer;
